import apiClient from './client';

// GET /api/audit-logs
// Filters: actor_id, entity_type, entity_id, action, from, to, page, limit
export async function fetchAuditLogs(params = {}) {
  const response = await apiClient.get('/audit-logs', { params });
  return response.data;
}
